import { render, staticRenderFns } from "./audit-item-templates.vue?vue&type=template&id=22da1b66"
import script from "./audit-item-templates.vue?vue&type=script&lang=js"
export * from "./audit-item-templates.vue?vue&type=script&lang=js"
import style0 from "./audit-item-templates.vue?vue&type=style&index=0&id=22da1b66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports